import { supabase } from './supabase';
import toast from 'react-hot-toast';

// Get current user with caching
async function getCurrentUser() {
  const { data: { user }, error } = await supabase.auth.getUser();
  if (error) throw error;
  if (!user) throw new Error('Not authenticated');
  return user;
}

// Generate a secure password
export async function generatePassword(): Promise<string> {
  try {
    const user = await getCurrentUser();

    // Generate password
    const chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    let password = '';
    for (let i = 0; i < 10; i++) {
      password += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    password += '!';
    
    // Save to password history
    const { error: insertError } = await supabase
      .from('password_history')
      .insert([{
        user_id: user.id,
        password
      }]);

    if (insertError) throw insertError;

    return password;
  } catch (error: any) {
    console.error('❌ Error generating password:', error);
    throw new Error(`Failed to generate password: ${error.message}`);
  }
}

// Get next available line
export async function getNextLine(): Promise<string> {
  try {
    const user = await getCurrentUser();

    // Get and delete random line using RPC function
    const { data: lines, error: fetchError } = await supabase
      .rpc('get_next_available_line', {
        user_id: user.id
      });

    if (fetchError) throw fetchError;
    if (!lines?.length) throw new Error('No available lines');

    // Log the line retrieval with the actual content
    await supabase
      .from('system_logs')
      .insert([{
        user_id: user.id,
        action: 'GET_LINE',
        details: `Retrieved line: ${lines[0].content}`
      }]);

    return lines[0].content;
  } catch (error: any) {
    console.error('❌ Error getting line:', error);
    throw new Error(`Failed to get line: ${error.message}`);
  }
}